const initialState = {
  fetching: false,
  pages: [],
  appearance_settings: {},
  error: null
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOAD_INBIO_CONTENTS_REQUEST":
      return {
        ...state,
        fetching: true,
        error: null,
      };
    case "LOAD_INBIO_CONTENTS_SUCCESS":
      return {
        ...state,
        fetching: false,
        pages: action.data.pages,
        appearance_settings: action.data.appearance_settings,
        error: action.data.error,
      };
    case "LOAD_INBIO_CONTENTS_FAILURE":
      return {
        ...state,
        fetching: false,
      };
    default:
      return state;
  }
};

export default Reducer;
